/**
 * 날짜 슬롯 변환 유틸리티
 * 백엔드에서 받은 날짜 슬롯 데이터를 프론트엔드에서 사용할 수 있는 형식으로 변환
 */

import { formatDate, formatTime } from './dateTimeUtils';

/**
 * 날짜 슬롯 변환 함수
 * @param {Array} rawSlots - 백엔드에서 받은 원본 날짜 슬롯 배열
 * @returns {Array} 변환된 날짜 슬롯 배열
 */
export const transformDateSlots = (rawSlots) => {
  const slots = Array.isArray(rawSlots) ? rawSlots : [];

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return slots.map((slot, idx) => {
    const max = slot.maxParticipants ?? 0;
    const current = slot.currentParticipants ?? 0;

    // 날짜가 지났는지 확인
    const rawDate = slot.date ? new Date(slot.date) : null;
    const isPast = rawDate && !isNaN(rawDate) ? rawDate < today : false;

    // available 상태 계산 (날짜 지난 슬롯은 unavailable)
    const available =
      isPast
        ? false
        : slot.available !== undefined && slot.available !== null
        ? slot.available
        : max > 0
        ? max - current > 0
        : true;

    // 남은 자리 수 계산
    const left =
      max > 0 && current >= 0 ? Math.max(max - current, 0) : null;

    return {
      id: slot.id ?? idx,
      date: slot.date ? formatDate(slot.date) : slot.dateText ?? '',
      time:
        slot.startTime || slot.endTime
          ? formatTime(slot.startTime, slot.endTime)
          : slot.time ?? '',
      startTime: slot.startTime,
      endTime: slot.endTime,
      maxParticipants: slot.maxParticipants,
      currentParticipants: slot.currentParticipants,
      available,
      isPast,
      dateSlotStatus: slot.status,
      status: isPast ? 'Ended' : available ? (left !== null ? `${left} left` : 'Available') : 'Full',
    };
  });
};

